import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProcurementModelBasicModel, SearchModel, SearchResultModel } from 'src/common';
import { environment } from 'src/environments/environment';

const localApiUrl = `${environment.apiUrl}/ProcurementModels`;

@Injectable()
export class ProcurementModelsService {

  constructor(private http: HttpClient) { }

  getAll(): Promise<ProcurementModelBasicModel[]> {
    return this.http.get<ProcurementModelBasicModel[]>(`${localApiUrl}/All`).toPromise();
  }

  getById(id: number): Promise<ProcurementModelBasicModel> {
    return this.http.get<ProcurementModelBasicModel>(`${localApiUrl}/GetById/${id}`).toPromise();
  }
}
